<template>
  <div class="clientOperateResult defatult-bg">
    <p class="clientOperateResult-p">参会信息填写</p>
    <div class="clientOperateResult-notes">参会信息提交后，可点击本链接再次修改。</div>
    <div id="clientOperateContent">
      <div style="height: 100%;">
        <div class="check-item" style="padding-top: 18px;">
          <p><span >*</span>1、本次会议时间为2026年3月27日（周五）全天，请您选择会议期间住宿安排：</p>
          <p class="remarkText">酒店当天下午2点后可办理入住，如您提前到达酒店，行李可寄存在礼宾部，感谢您的理解！</p>
          <van-radio-group v-model="resultForm.accomodation" >
            <template v-for="(item,index) in constants.AccomodationOptions">
              <van-radio :name="item.value" :key="index" @click.native="onAccomodationChange">{{ item.label }}</van-radio>
            </template>
          </van-radio-group>
        </div>
        <div class="check-item">
          <p><span >*</span>2、请问您是否参加会议当天招待晚宴：</p>
          <van-radio-group v-model="resultForm.dinner">
            <template v-for="(item,index) in constants.DinnerOptions">
              <van-radio :name="item.value" :key="index">{{ item.label }}</van-radio>
            </template>
          </van-radio-group>
        </div>
        <div class="client-line"/>
        <div class="check-item">
          <p><span >*</span>3、接机/站安排：</p>
          <p class="remarkText">本服务由第三方平台提供，仅支持到达站点前往会议酒店，感谢您的理解！</p>
          <van-radio-group v-model="resultForm.receive">
            <template v-for="(item,index) in constants.ReceiveOptions">
              <van-radio :name="item.value" :key="index">{{ item.label }}</van-radio>
            </template>
          </van-radio-group>
        </div>
        <div class="check-item" v-if="noReceive">
          <p><span >*</span>联系电话：</p>
          <p class="remarkText">届时司机将联系该号码为您服务</p>
          <van-field v-model="resultForm.receivePhone" class="bottomBorder" name="联系电话" placeholder="请输入"
                     @blur="testPhone('receive')"/>
        </div>
        <div class="check-item" v-if="noReceive">
          <p><span >*</span>到达站点：</p>
          <van-radio-group v-model="resultForm.receiveStation">
            <template v-for="(item,index) in constants.StationOptions">
              <van-radio :name="item.value" :key="index">{{ item.label }}</van-radio>
            </template>
          </van-radio-group>
          <p class="remarkText">福田高铁站可从10号出口步行到达酒店。</p>
        </div>
        <div class="check-item" v-if="noReceive && !noReceiveStation">
          <p><span >*</span>航班号/车次：</p>
          <van-field v-model="resultForm.receiveNumber" class="bottomBorder" name="航班号/车次" placeholder="MUXXXX或GXXXX"/>
        </div>
        <div class="check-item" v-if="noReceive && !noReceiveStation" @click="openReceive">
          <p><span >*</span>到达时间：</p>
          <p style="padding-top: 10px;"><i class="el-icon-date" style="margin-right:10px;"></i>{{ resultForm.receiveTime | currentDateFilter }}</p>
        </div>

        <div class="check-item" v-if="noReceive">
          <p>如有同行人需乘坐同一车辆，请填写同行人姓名：</p>
          <van-field v-model="resultForm.receiveCompany" class="bottomBorder" name="同行人姓名" placeholder="张三或张三、李四"/>
        </div>
        <div class="client-line"/>
        <div class="check-item">
          <p><span >*</span>4、送机/站安排：</p>
          <p class="remarkText">本服务由第三方平台提供，仅支持会议酒店前往出发站点，感谢您的理解！</p>
          <van-radio-group v-model="resultForm.send" @change="sendChange">
            <template v-for="(item,index) in constants.ReceiveOptions">
              <van-radio :name="item.value" :key="index">{{ item.label }}</van-radio>
            </template>
          </van-radio-group>
        </div>
        <div class="check-item" v-if="noSend">
          <p><span >*</span>联系电话：</p>
          <p style="color: #969799;margin-top: 5px;font-size: 14px;font-weight: normal;">届时司机将联系该号码为您服务</p>
          <!-- <p style="color: #969799;margin-top: 5px;font-size: 14px;font-weight: normal;">返程时请您使用【<b>滴滴出行APP/小程序</b>】自行叫车，我们将为您提供【<b>出行券</b>】至预留手机号，限有效期内单次抵扣，请留意短信通知及APP-我的卡券-优惠券。</p> -->
          <van-field v-model="resultForm.sendPhone" class="bottomBorder" name="联系电话" placeholder="请输入联系电话"
                     @blur="testPhone('send')"/>
        </div>
        <div class="check-item" v-if="noSend">
          <p><span >*</span>出发站点：</p>
          <van-radio-group v-model="resultForm.sendStation">
            <template v-for="(item,index) in constants.StationOptions">
              <van-radio :name="item.value" :key="index">{{ item.label }}</van-radio>
            </template>
          </van-radio-group>
          <p class="remarkText">福田高铁站可从酒店步行到达，最近出入口为10号口。</p>
        </div>
        <div class="check-item" v-if="noSend && !noSendStation" @click="openSend">
          <p><span >*</span>酒店出发时间：</p>
          <p style="padding-top: 10px;"><i class="el-icon-date" style="margin-right:10px;"></i>{{ resultForm.sendTime | currentDateFilter }}</p>
        </div>
        <div class="clientOperateResultBthGroup">
          <van-button type="info" @click="onUpdateClient"
                      style="background-color: #134CDB;margin-bottom: 35px;margin-top: 30px;border:0;" :disabled="updateClientDisabled">
            提交<van-loading type="spinner" v-if="updateClientDisabled" size="18px" style="display: inline-block;margin-left: 8px;" />
          </van-button>
        </div>
      </div>
    </div>
    <van-popup v-model="show" position="bottom" :style="{ height: '330px' }">
      <van-picker
          show-toolbar
          ref="receiveTimeRef"
          :columns="receiveDateColumns"
          @cancel="closeDate"
      >
        <div slot="default" class="dateTitle">
          <div style="justify-content: space-between">
            <van-button type="default" @click="closeDate" size="small">取消</van-button>
            <div>选择时间</div>
            <van-button type="default" @click="onReceiveTimeConfirm" size="small" class="date-submit-btn">确定</van-button>
          </div>
          <div style="display: flex;">
            <div class="dateTextTitle date-with">日期</div>
            <div class="dateTextTitle">时</div>
            <div class="dateTextTitle">分</div>
          </div>
        </div>
      </van-picker>
    </van-popup>
    <van-popup v-model="sendShow" position="bottom" :style="{ height: '330px' }">
      <van-picker
          show-toolbar
          ref="sendTimeRef"
          :columns="sendDateColumns"
          @cancel="closeDate"
      >
        <div slot="default" class="dateTitle">
          <div style="justify-content: space-between">
            <van-button type="default" @click="closeDate" size="small">取消</van-button>
            <div>选择时间</div>
            <van-button type="default" @click="onSendTimeConfirm" size="small" class="date-submit-btn">确定</van-button>
          </div>
          <div style="display: flex;">
            <div class="dateTextTitle date-with">日期</div>
            <div class="dateTextTitle">时</div>
            <div class="dateTextTitle">分</div>
          </div>
        </div>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import {dateFormat, getMobileTest} from '@/util/common'
import {queryResult, updateClientResult} from '@/service/invitationClientApis'
import lodash from 'lodash'
import constants, {
  Accomodation01,
  Attend01,
  Receive01,
  Station04,
  ReceiveDateRange,
  SendDateRange, Date02
} from "@/util/constants";
import moment from "moment";
import {Shares} from '@/util/Share'


const DateMatch = 'YYYY年MM月DD日 HH:mm'

export default {
  name: 'clientOperateResult',
  data() {
    return {
      constants,
      resultForm: {
        accomodation: '',
        dinner: '',
        receive: '',
        receivePhone: '',
        receiveStation: '',
        receiveNumber: '',
        receiveTime: '',
        receiveCompany: '',
        send: '',
        sendPhone: '',
        sendStation: '',
        sendTime: ''
      },
      show: false,
      sendShow: false,
      leastQuestion: {
        accomodation: '',
        dinner: '',
        receive: '',
        receivePhone: '',
        receiveStation: '',
        receiveNumber: '',
        receiveTime: '',
        receiveCompany: '',
        send: '',
        sendPhone: '',
        sendStation: '',
        sendTime: ''
      },
      updateClientDisabled:false
    }
  },
  computed: {
    noReceive() {
      return this.resultForm.receive === Receive01
    },
    noSend() {
      return this.resultForm.send === Receive01
    },
    clientId() {
      return this.$store.state.base.clientId
    },
    noReceiveStation() {
      return !this.resultForm.receiveStation || this.resultForm.receiveStation === Station04
    },
    noSendStation() {
      return !this.resultForm.sendStation || this.resultForm.sendStation === Station04
    },
    sendDateColumns() {
      return this.resultForm.accomodation ? SendDateRange[this.resultForm.accomodation] : SendDateRange[Accomodation01]
    },
    receiveDateColumns() {
      return this.resultForm.accomodation ? ReceiveDateRange[this.resultForm.accomodation] : ReceiveDateRange[Accomodation01]
    },
  },
  filters: {
    currentDateFilter(val) {
      if (val) {
        return dateFormat(val, DateMatch)
      } else {
        return ''
      }
    }
  },
  methods: {
    onAccomodationChange(){
      console.log('onAccomodationChange')
      this.resultForm= {
        ...this.resultForm,
        receiveStation:"",
        receiveNumber:"",
        receiveTime:"",
        receiveCompany:"",
        sendStation:"",
        sendTime:""
      }
    },
    async openReceive() {
      this.show = true
      if (this.show) {
        this.$nextTick(() => {
          const {receiveTime} = this.resultForm
          const dateStr = moment(new Date(receiveTime)).format('YYYY年MM月DD日')
          const hourStr = moment(new Date(receiveTime)).format('HH')
          const minStr = moment(new Date(receiveTime)).format('mm')
          this.$refs.receiveTimeRef.setValues([dateStr, hourStr, minStr])
        })
      }
    },
    onReceiveTimeConfirm() {
      const values = this.$refs.receiveTimeRef.getValues() || []
      const [dateStr, hourStr, minStr] = values;
      this.resultForm.receiveTime = `${constants.DateTextMap[dateStr.text]} ${hourStr.text}:${minStr.text}`
      this.closeDate()
    },
    openSend() {
      this.sendShow = true
      this.$nextTick(() => {
        const {sendTime} = this.resultForm
        const dateStr = moment(new Date(sendTime)).format('YYYY年MM月DD日')
        const hourStr = moment(new Date(sendTime)).format('HH')
        const minStr = moment(new Date(sendTime)).format('mm')
        this.$refs.sendTimeRef.setValues([dateStr, hourStr, minStr])
      })
    },
    onSendTimeConfirm() {
      const values = this.$refs.sendTimeRef.getValues() || []
      const [dateStr, hourStr, minStr] = values
      this.resultForm.sendTime = `${constants.DateTextMap[dateStr.text]} ${hourStr.text}:${minStr.text}`
      this.closeDate()
    },
    sendChange(val) {
      if (val === Receive01 && this.resultForm.receivePhone) {
        this.resultForm.sendPhone = this.resultForm.receivePhone
      } else {
        this.resultForm.sendPhone = ''
      }
    },
    testPhone(type) {
      if (type === 'receive') {
        if (getMobileTest(this.resultForm.receivePhone)) {
          if (!this.resultForm.sendPhone) {
            this.resultForm.sendPhone = this.resultForm.receivePhone
          }
        } else {
          this.$message.warning('联系电话格式有误，请您再次确认。')
          return
        }
      }
      if (type === 'send' && !getMobileTest(this.resultForm.sendPhone)) {
        this.$message.warning('联系电话格式有误，请您再次确认。')
        return
      }
    },
    onUpdateClient: lodash.debounce(async function () {
      if(this.updateClientDisabled){
        return
      }
      this.updateClientDisabled = true
      const {
        receiveTime, sendTime, receive, send, accomodation, dinner, receiveCompany,
        receiveNumber, receivePhone, receiveStation, sendNumber, sendPhone, sendStation
      } = this.resultForm
      let resultForm = {
        ...this.resultForm,
        attend: Attend01,
        clientId: this.clientId,
        receiveTime: receiveTime && receive === Receive01 ? dateFormat(receiveTime, 'YYYY/MM/DD HH:mm') : '',
        sendTime: sendTime && send === Receive01 ? dateFormat(sendTime, 'YYYY/MM/DD HH:mm') : '',
        receiveCompany: receive === Receive01 ? receiveCompany : '',
        receiveNumber: receive === Receive01 ? receiveNumber : '',
        receivePhone: receive === Receive01 ? receivePhone : '',
        receiveStation: receive === Receive01 ? receiveStation : '',
        sendNumber: send === Receive01 ? sendNumber : '',
        sendPhone: send === Receive01 ? sendPhone : '',
        sendStation: send === Receive01 ? sendStation : '',
      }

      let _msg = ''
      if (!accomodation && !_msg) {
        _msg = '请您选择住宿安排'
      } else if (!dinner && !_msg) {
        _msg = '请您确认是否参加会议当天招待晚宴'
      } else if (!receive && !_msg) {
        _msg = '请您确认是否接机/站安排'
      }

      if (receive === Receive01 && !_msg) {
        if (!receivePhone) {
          _msg = '请您输入接机联系电话'
        } else if (receivePhone && !getMobileTest(receivePhone)) {
          _msg = '联系电话格式有误，请您再次确认。'
        } else if (!receiveStation) {
          _msg = '请您确定接机/站安排的到达站点'
        } else if (receiveStation !== Station04 && !receiveNumber) {
          _msg = '请您输入接机/站安排的航班号/车次'
        } else if (receiveStation !== Station04 && !receiveTime) {
          _msg = '请您确定到达时间'
        } else if (receiveStation === Station04) {
          resultForm.receiveNumber = ''
          resultForm.receiveTime = ''
        }
      }

      if (!send && !_msg) {
        _msg = '请您确认是否送机/站安排'
      }

      if (send === Receive01 && !_msg) {
        if (!sendPhone) {
          _msg = '请您输入送机/站安排的联系电话'
        } else if (sendPhone && !getMobileTest(sendPhone)) {
          _msg = '送机/站安排的联系电话格式有误，请您再次确认。'
        } else if (!sendStation) {
          _msg = '请您确定送机/站安排的出发站点'
        } else if (sendStation !== Station04 && !sendTime) {
          _msg = '请您确定酒店出发时间'
        } else if (sendStation === Station04) {
          resultForm.sendTime = ''
        }
      }

      if (_msg) {
        this.$message({message: _msg, type: 'warning', duration: 5000})
        this.updateClientDisabled = false
        return
      }
      const editFrom = {...this.resultForm}
      let isNoDiff = true
      for (const key in editFrom) {
        if (editFrom.hasOwnProperty(key) && editFrom[key] !== this.leastQuestion[key]) {
          isNoDiff = false
        }
      }
      if (isNoDiff) {
        this.updateClientDisabled = false
        this.$router.push({name: 'clientResult2024'})
      } else {
        let res = await updateClientResult(resultForm)
        this.updateClientDisabled = false
        if (res) {
          let {code, msg} = res
          if (code === '0') {
            this.$router.push({name: 'clientResult2024'})
          } else {
            this.$message.error(msg || '服务异常，请联系客服')
          }
        }
      }
    }, 300,{
      leading: true,
      trailing: false
    }),
    closeDate() {
      this.show = false
      this.sendShow = false
    },

  },
  async mounted() {
    Shares.shareCode()
    if(this.clientId) {
      let historyDataRes = await queryResult({clientId: this.clientId})
      if (historyDataRes) {
        let {code, msg} = historyDataRes
        if (code === '0') {
          for (let key in this.resultForm) {
            if (key === 'receiveTime' || key === 'sendTime') {
              this.resultForm[key] = historyDataRes[key] ? new Date(historyDataRes[key]) : ''
            } else {
              this.resultForm[key] = historyDataRes[key]
            }
          }
          this.leastQuestion = {...this.resultForm}
        } else {
          this.$message.error(msg || '服务异常，请联系客服')
        }
      }
    } else {
      this.$router.push({name: 'clientLogin2024'})
    }
    console.log(this.receiveDateColumns, 'receiveDateColumns========')
  }
}
</script>

<style lang="less">
.clientOperateResult {
  position: relative;
  height: 100vh !important;
  box-sizing: border-box;
  padding-bottom: 46px;
  overflow: auto;

  #clientOperateContent {
    border-radius: 10px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin: 0 16px;
    margin-top: 30px;
    background: #fff;
  }

  .clientOperateResult-p {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    padding-top: 40px;
    // height: 12vh;
    // line-height: 12vh;
    margin: 0;
    color: #fff;
  }
  .clientOperateResult-notes {
    padding: 0 16px;
    font-size: 14px;
    margin-top: 5px;
    text-align: center;
    color: #bcbcbc;
  }

  .check-item {
    background-color: #fff;
    padding: 14px 16px;

    > p {
      margin: 0;
      line-height: 24px;
      padding-bottom: 5px;
      font-size: 18px;
      position: relative;
      >span{
        position: absolute;
        left: -9px;
        top: 3px;
        color:red;
      }
    }

    .bottomBorder {
      border: 1px solid #dcdfe6;
      border-radius: 3px;
      font-size: 16px;
      padding-top: 6px;
      padding-bottom: 6px;
      padding-left: 5px;
    }

    .remarkText {
      color: #999;
      margin-top: 5px;
      font-size: 14px;
      font-weight: normal;
      font-size: 13px;
      font-weight: normal;
      line-height: 18px;
    }

    .van-radio {
      height: 42px;
      line-height: 42px;

      &:last-child {
        border-bottom: 0;
      }
    }

  }

  .van-picker__toolbar {
    height: 60px;
  }

  .dateTitle {
    width: 100%;
    background: #fff;

    > div {
      background: #fff;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border-bottom: 1px solid #ebeef5;
    }
  }

  .dateTextTitle {
    flex: 1;
    text-align: center;
    line-height: 24px;
    height: 24px;
  }

  .clientOperateResultBthGroup {
    height: 90px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    > button {
      width: 80%;
      height: 48px;
      line-height: 48px;
    }
  }

  .van-button--small {
    padding: 0 18px;
    font-size: 14px;
  }

  .date-submit-btn {
    background-color: #1989fa;
    border-color: #1989fa;
    color: #fff;
  }

  .van-picker-column:first-child, .date-with {
    min-width: 135px;
  }
  .client-line{
    border-bottom: 1px solid #dcdfe6;
    margin: 0px 16px 14px;
  }
}
</style>
